"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function () {
    if (!Event.prototype.preventDefault) {
        Event.prototype.preventDefault = function () {
            this.returnValue = false;
        };
    }
    if (!Event.prototype.stopPropagation) {
        Event.prototype.stopPropagation = function () {
            this.cancelBubble = true;
        };
    }
    if (!Element.prototype.addEventListener) {
        var eventListeners_1 = [];
        var addEventListener_1 = function (type, listener) {
            var self = this;
            var wrapper = function (element) {
                element.target = element.srcElement;
                element.currentTarget = self;
                if (typeof listener.handleEvent != "undefined") {
                    listener.handleEvent(element);
                }
                else {
                    listener.call(self, element);
                }
            };
            if (type == "DOMContentLoaded") {
                var wrapper2 = function (element) {
                    if (window.readyState == "complete")
                        wrapper(element);
                };
                window.attachEvent("onreadystatechange", wrapper2);
                eventListeners_1.push({
                    object: this,
                    type: type,
                    listener: listener,
                    wrapper: wrapper2,
                });
                if (window.readyState == "complete") {
                    var element = new Event("");
                    element.srcElement = window;
                    wrapper2(element);
                }
            }
            else {
                this.attachEvent("on" + type, wrapper);
                eventListeners_1.push({
                    object: this,
                    type: type,
                    listener: listener,
                    wrapper: wrapper,
                });
            }
        };
        var removeEventListener_1 = function (type, listener) {
            var counter = 0;
            while (counter < eventListeners_1.length) {
                var eventListener = eventListeners_1[counter];
                if (eventListener.object == this &&
                    eventListener.type == type &&
                    eventListener.listener == listener) {
                    if (type == "DOMContentLoaded")
                        this.detachEvent("onreadystatechange", eventListener.wrapper);
                    else
                        this.detachEvent("on" + type, eventListener.wrapper);
                    eventListeners_1.splice(counter, 1);
                    break;
                }
                ++counter;
            }
        };
        Element.prototype.addEventListener = addEventListener_1;
        Element.prototype.removeEventListener = removeEventListener_1;
        if (HTMLDocument) {
            HTMLDocument.prototype.addEventListener = addEventListener_1;
            HTMLDocument.prototype.removeEventListener = removeEventListener_1;
        }
        if (Window) {
            Window.prototype.addEventListener = addEventListener_1;
            Window.prototype.removeEventListener = removeEventListener_1;
        }
    }
})();
//# sourceMappingURL=event-listener.js.map